import {
  PERMISSION_CREATE,
  PERMISSION_OBJ_TRANSIT_ORDER,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@/constants/permissions';

import { Form } from './components/form';
import { LotsSelector } from './components/selector';
import { TransitOrders } from './components/table';

export const states = [
  {
    name: 'base-layout.transit-orders',
    url: '/transit-orders',
    component: TransitOrders,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_TRANSIT_ORDER, PERMISSION_READ]],
    },
  },
  {
    name: 'base-layout.transit-orders.create',
    url: '/new',
    component: Form,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_TRANSIT_ORDER, PERMISSION_CREATE]],
    },
  },
  {
    name: 'base-layout.transit-orders.edit',
    url: '/:transitOrderId/edit',
    component: Form,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_TRANSIT_ORDER, PERMISSION_UPDATE]],
    },
  },
  {
    name: 'base-layout.transit-orders.lots',
    url: '/:transitOrderId/lots',
    component: LotsSelector,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_TRANSIT_ORDER, PERMISSION_UPDATE]],
    },
  },
];
